export default __webpack_public_path__ + "static/media/team.39ce4c00.jpg";